import { interpolate, t } from './i18n.js';

$( document ).ready(function() {
    let $voices = $('#song-voices-repeater');
    let isDataCleaned = false;
    let $songVoiceSelect = $('.song-voice-select2').not('[data-template=true]');
    let $addButton = $('[data-repeater-create]');

        const select2Options = {
        placeholder: t('selectNewOrExistingVoice'),
        allowClear: true,
        tags: true,
        createTag: function (params) {
          const term = $.trim(params.term);

          if (term === '') {
            return null;
          }

          return {
            id: term,
            text: interpolate(t('newVoiceLabel'), { voice: term }),
            newTag: true // Add this property to indicate this is a new tag
          };
        }
    };

    // If inside a Bootstrap modal, keep dropdown within modal and above backdrop
    const $modalAncestor = $voices.closest('.modal');
    if ($modalAncestor.length) {
        select2Options.dropdownParent = $modalAncestor;
    }

    if($voices.length > 0){
        $voices.repeater({
          initEmpty: $voices.data('init-empty'),
          ready: function (setIndexes) {
            $songVoiceSelect.select2(select2Options);
            toggleDefaultVoiceCheckbox();
            toggleAutoAssignCheckbox(); // Check all existing voice items

            // In case of backend validation: set newly created voices in select2 inputs
            $('.song-voice-item:not(.template)').each((i, item) => {
                let $item = $(item);
                let newVoiceName = $('.song-voice-text-input', $item).val();
                if(typeof newVoiceName !== 'undefined' && newVoiceName !== ''){
                    const readableName = interpolate(t('newVoiceLabel'), { voice: newVoiceName })
                    $(".select2-selection__rendered", $item)
                        .attr('title', readableName)
                        .text(readableName)
                    ;
                }
            });

            $(document).on('select2:select', '.song-voice-select2', (e) => {
                const data = e.params.data;
                let $wrapper = $(e.currentTarget).closest('.song-voice-item');
                let $select = $('.song-voice-select2', $wrapper);
                // Check if the selected option is a new tag
                if (data.newTag) {

                  $('.song-voice-text-input', $wrapper).val(data.id)
                  $select.attr('data-name', $select.attr('name'));
                  $select.removeAttr('name');
                } else {
                  $('.song-voice-text-input', $wrapper).val('');
                  $select.attr('name', $select.attr('data-name'));
                }

                toggleAddButton();
                toggleAutoAssignCheckbox($wrapper);
            });

            $(document).on("select2:open", '.song-voice-select2', () => {
                document.querySelector(".select2-container--open .select2-search__field").focus()
            })

            // Track manual changes to auto-assign checkboxes
            $(document).on('change', '.auto-assign-members', function() {
                $(this).data('manually-changed', true);
            });

            $(document).on('click', '.list-move-up', function(e) {
                let $wrapper = $(this).closest('.song-voice-item');
                let $prev = $wrapper.prev();
                if($prev){
                    $wrapper.fadeOut(200, ()=>{
                        $wrapper.insertBefore($prev.first());
                        setVoicesOrder();
                        setIndexes();
                        $wrapper.fadeIn(200);
                    });
                }
            });
            $(document).on('click', '.list-move-down', function(e) {
                let $wrapper = $(this).closest('.song-voice-item');
                let $next = $wrapper.next();
                if($next){
                    $wrapper.fadeOut(200, ()=>{
                        $wrapper.insertAfter($next.first());
                        setVoicesOrder();
                            setIndexes();
                        $wrapper.fadeIn(200);
                    });
                }
            });
          },
          show: () => {
            setVoicesOrder();
            $addButton.addClass('disabled'); // prevent adding next voice if some is not yet filled
            $('.song-voice-select2', $voices)
                .not('.select2-hidden-accessible')
                .select2(select2Options)
                .closest('.song-voice-item')
                .removeClass('template')
                .find('.error').remove();
            toggleDefaultVoiceCheckbox();
            toggleAutoAssignCheckbox(); // Check newly added voice item
          },
          hide: (deleteElement) => {
            deleteElement();
            toggleAddButton();
            toggleDefaultVoiceCheckbox();
            toggleAutoAssignCheckbox(); // Update checkboxes after deletion
          }
        });
    }
});

function setVoicesOrder(){
    const $voices = $('#song-voices .song-voice-item');
    let itemOrder = 0;

    $voices.each((i, voice) => {
        const $voice = $(voice);
        itemOrder += 1;
        $('input.song-voice-item-order-input', $voice).val(itemOrder);
//        $('.voice-order', $voice).text(itemOrder);
    });
}

function toggleAddButton(){
    let $addButton = $('[data-repeater-create]');
    let emptyVoiceLeft = false;
    $('.song-voice-item:not(.template)').each((i) => {
        let $item = $(this);

        if($('.song-voice-text-input', $item).val() === '' && $('.song-voice-select2', $item).val() === ''){
            emptyVoiceLeft = true;
            return false;
        }
    });

    if(emptyVoiceLeft){
        $addButton.addClass('disabled');
    } else {
        $addButton.removeClass('disabled');
    }
}

function toggleDefaultVoiceCheckbox(){
    let $checkboxWrapper = $('#default-voice-checkbox-wrapper');

    if($('.song-voice-item:not(.template)').length === 0) {
        $checkboxWrapper.removeClass('d-none');
    } else {
        $checkboxWrapper.addClass('d-none');
    }
}

function toggleAutoAssignCheckbox($wrapper) {
    if (!$wrapper) {
        // If no specific wrapper provided, update all voice items
        $('.song-voice-item:not(.template)').each(function() {
            toggleAutoAssignCheckbox($(this));
        });
        return;
    }
    
    const $select = $('.song-voice-select2', $wrapper);
    const $checkbox = $('.auto-assign-checkbox', $wrapper);
    const $checkboxInput = $('.auto-assign-members', $wrapper);
    const selectedVoiceId = $select.val();
    
    // Get main voice IDs from data attribute
    const mainVoicesData = $('#song-voices-repeater').data('main-voices');
    const mainVoiceIds = mainVoicesData ? mainVoicesData.toString().split(',').map(id => id.trim()) : [];
    
    if (selectedVoiceId && mainVoiceIds.includes(selectedVoiceId)) {
        $checkbox.removeClass('d-none');
        // Ensure checkbox is checked when shown (unless user manually unchecked it)
        if (!$checkboxInput.data('manually-changed')) {
            $checkboxInput.prop('checked', true);
        }
    } else {
        $checkbox.addClass('d-none');
        // Reset manual change tracking when hidden
        $checkboxInput.removeData('manually-changed');
    }
}
